
import React, { useState, useEffect, useRef, useContext } from 'react';
import { Modal, Input, Row, Col, Tabs, Button, Card, Tooltip, message, Empty } from 'antd';
import axios from 'axios';
import _ from "lodash" // Import the entire lodash library
import { ArrowLeftOutlined, CheckOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import CollaborateQAContext from '../../ContextFiles/CollaborateQAContext';
import DottedLoader from '../../DottedLoader';
import ENVIRONMENT from '../../../../environments';
import * as Utilities from '../../Utilities'
import AiProductBadge from '../AiProduct/AiProductBadge';
import { QA_IMG_URI } from '../../../../environments/env';
import FileConstants from '../../../../FileConstants';
import RenderInProgressImage from '../../../../assets/images/scene_incomplete.svg'

const { TabPane } = Tabs;

const COMPANY_ID = localStorage.getItem('company_id');
const MANAGED_COMPANY_ID = localStorage.getItem('managed_company_id');
const CUSTOMER_USERNAME = localStorage.getItem("username");
const SHARED_ENTITIES = localStorage.getItem('shared_entities');
const IS_MS_PROVIDER = localStorage.getItem("is_msprovider") === 'true' ? true : false;
const MANAGED_CUSTOMER_USERNAME = localStorage.getItem('managed_customer_username');


const ProductAssetSelectionModal = () => {
    const { setRefImgModal, selectReferences, sharedProductLoader, ownedProductLoader,
        setOtherFilteredData, otherFilteredData, ownedData, otherData, selectedProductID, setSelectedProductID,
        ownedFilteredData, setOwnedFilteredData, setOpenProductImageSelectionModal, openProductImageSelectionModal } = useContext(CollaborateQAContext);
    const [libraryType, setLibraryType] = useState('OwnedLibrary')
    const [searchValue, setSearchValue] = useState("");
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [selectedProductId, setSelectedProductId] = useState(selectedProductID)
    const [productDataLoader, setProductDataLoader] = useState(false);
    const [selectionStage, setSelectionStage] = useState("product_selection");
    const [selectedImages, setSelectedImages] = useState([]);
    const [productImages, setProductImages] = useState([]);
    const [productAssetData, setProductAssetData] = useState(null);
    const [allAiImages, setAllAiImages] = useState([]);

    const cancelAddProductModal = () => {
        setSelectedImages([]);
        setProductImages([]);
        setAllAiImages([]);
        setOpenProductImageSelectionModal(false);
        setSelectedProductId(-1);
        setSelectedProductID(-1);
        if (selectionStage == "image_selection") {
            setSelectionStage("product_selection");
        }
    }

    const handleConfirm = () => {
        if (selectedProductId) {
            setSelectedProductID(selectedProductId)
            loadProductAssets(selectedProductId);
        }
        else {
            message.error('Please select a product')
        }
    }

    const handleAdd = () => {
        setProductImages([]);
        setSelectedImages([]);
        setProductAssetData([]);
        setAllAiImages([]);
        setSelectedProductId(-1);
        setSelectedProductID(-1);
        setOpenProductImageSelectionModal(false);
        setSelectionStage("product_selection");
        selectReferences(selectedImages);
        setRefImgModal(false);


    }

    const loadProductAssets = (product_id) => {
        setProductDataLoader(true);
        let payload = {}
        if (IS_MS_PROVIDER) {
            payload = { product_id: product_id, username: MANAGED_CUSTOMER_USERNAME }
            if (MANAGED_COMPANY_ID) {
                payload.company_id = MANAGED_COMPANY_ID
            }
        } else {
            payload = { product_id: product_id, username: CUSTOMER_USERNAME }
            if (COMPANY_ID != null) {
                payload.company_id = COMPANY_ID
            }
        }

        axios.post(ENVIRONMENT.FETCH_PRODUCT, {
            'product_id': product_id,
        })
            .then(res => {
                console.log(res.data);

                if (res?.data?.is_ai_model) {
                    fetchAiData(product_id);
                }
                axios.post(ENVIRONMENT.RENDER_PRODUCT, payload)
                    .then(res => {
                        console.log(res.data);
                        setProductDataLoader(false);
                        setSelectionStage("image_selection");
                        let company_id = null;
                        if (res.data['company_id'] != undefined) {
                            let current_company = COMPANY_ID;
                            if (current_company === res.data['company_id'].toString() || FileConstants.isMSProvider) {
                                company_id = res.data['company_id'].toString();
                            }
                        }
                        setProductAssetData(res.data);
                        allSystemGeneratedProductImages(res.data, product_id, company_id);
                    });
            })
    }

    const fetchAiData = (product_id) => {
        axios.post(ENVIRONMENT.AI_MODEL_HELPER, {
            'action': 'get_ai_assets',
            'product_id': product_id,
            'username': CUSTOMER_USERNAME,
            'company_id': COMPANY_ID || null
        })
            .then((res) => {
                if (res.data) {
                    let image_list = [];
                    (res.data.lifestyle_renders || []).map((lifestyle) => {
                        image_list.push({
                            "format": lifestyle.uri?.split('.')[lifestyle.uri.split('.').length - 1],
                            "link": lifestyle.uri ? ENVIRONMENT.getBaseURL('aws') + lifestyle.uri : RenderInProgressImage,
                            "low_url": lifestyle.uri ? ENVIRONMENT.getBaseURL('aws') + lifestyle.uri : RenderInProgressImage,
                            "type": 'ai_lifestyle',
                            "main_type": 'ai_lifestyle',
                            "image_type": 'ai_lifestyle',
                            "status": lifestyle.status === 'completed' ? 'rendered' : 'pending',
                            "filename": lifestyle.uri,
                            "display_name": lifestyle.display_name ?? lifestyle.prompt_text,
                            "resolution": lifestyle.resolution,
                            "created_at": lifestyle.submitted_on,
                            "id": lifestyle.id,
                            "captured_by": lifestyle.username
                        });
                    });

                    setAllAiImages(image_list);
                }
            })
    }

    useEffect(() => {
        if (searchValue) {
            let filteredOwnedData = Utilities.getRelevanceBasedOrderedSearchResult(searchValue, ownedData)
            let filteredOtherData = Utilities.getRelevanceBasedOrderedSearchResult(searchValue, otherData)
            setOwnedFilteredData(filteredOwnedData)
            setOtherFilteredData(filteredOtherData)
        }
        else {
            setOwnedFilteredData(ownedData)
            setOtherFilteredData(otherData)
        }
    }, [searchValue])

    const changeSearchValue = (value) => {
        setSearchValue(value);
    }

    const getTabTitle = (tab) => {
        if (libraryType == tab.key && searchValue == "" && !filtersApplied && tab.key != "store") {
            return tab.title + ` (${tab.data.length})`;
        }
        else return tab.title + ` (${tab.length})`;
    };

    const tabs = [
        {
            key: "OwnedLibrary",
            title: "Your Products",
            data: ownedFilteredData,
            originalData: ownedData,
            length: ownedFilteredData.length,
            loader: ownedProductLoader
        },
        {
            key: "OtherLibrary",
            title: "Other Products",
            data: otherFilteredData,
            originalData: otherData,
            length: otherFilteredData.length,
            loader: sharedProductLoader
        }
    ];

    useEffect(() => {
        if (ownedData.length === 0 && !ownedProductLoader) {
            setLibraryType("OtherLibrary")
        }
    }, [ownedData, ownedProductLoader])


    const handleAddAction = (product) => {
        if (selectedProductId == product.id) {
            setSelectedProductId(null)
        } else {
            setSelectedProductId(product.id)
        }
    }

    const goBack = () => {
        if (selectionStage == "image_selection") {
            setSelectedImages([]);
            setProductImages([]);
            setSelectionStage("product_selection");
        } else {
            setOpenProductImageSelectionModal(false);
            setSelectedImages([]);
            setProductImages([]);
            setRefImgModal(true);
        }
    }


    const allSystemGeneratedProductImages = (initial, product_id, company_id) => {
        console.log("checking initial", initial)
        let image_list = [];
        if (initial['silo_data'] && initial['silo_data'].length > 0) {
            let silo_image = [];
            initial['silo_data'].map((img) => {
                let image_link = '';

                //silos has different base URI for company/MSP and individual users, following logic caters that
                let silo_base_uri = ''
                if (img.username || img.company_id) {
                    // if silo img dict has username or company_id use that
                    // This will be the case when all silos for the project are retrieved
                    silo_base_uri = img.username
                    if (img.company_id) {
                        silo_base_uri = 'company/' + img.company_id
                    }
                }
                else {
                    silo_base_uri = CUSTOMER_USERNAME
                    if (company_id) {
                        silo_base_uri = 'company/' + company_id
                    }
                }

                let image_type = 'silo';
                if (img.image_status == "pending" || img.image_status == "requested") {
                    if (img.camera_name.includes('Mount') && img.camera_name.includes('inside')) {
                        image_link = require("../../../../assets/images/insideBlind.jpg");
                        image_type = 'blind';
                    } else if (img.camera_name.includes('Mount') && !img.camera_name.includes('inside')) {
                        image_link = require("../../../../assets/images/outsideBlind.jpg");
                        image_type = 'blind';
                    } else {
                        image_type = 'silo';
                        image_link = ENVIRONMENT.getBaseURL(initial['platform']) + QA_IMG_URI + product_id + '/' + silo_base_uri + '/' + img.camera_name + '_preview' + '.jpg';
                    }
                } else if (img.image_status == "completed") {
                    image_link = ENVIRONMENT.getBaseURL(initial['platform']) + QA_IMG_URI + product_id + '/' + silo_base_uri + '/' + img.camera_name + '.' + img.image_data.img_format;
                    image_link = image_link;
                    if (img.camera_name.includes('Mount')) {
                        image_type = 'blind'
                    } else if (img.camera_name.includes('swatch')) {
                        image_type = 'swatch'
                    } else {
                        image_type = "silo";
                    }
                }
                let filename = image_link.split('/').pop();
                let display_name = img.camera_display_name ? img.camera_display_name : img.camera_name.split('.')[0];

                if (!img.hasOwnProperty('is_hidden') || img.is_hidden !== true) {
                    silo_image.push({
                        "format": Utilities.getImageFormat(image_link),
                        "link": image_link.replace('tiff', 'jpg'),
                        "low_url": image_link.replace('tiff', 'jpg'),
                        "type": image_type,
                        "main_type": "silo",
                        "status": img.image_status,
                        "filename": filename,
                        "display_name": display_name,
                        "camera_name": img.camera_name,
                        "resolution": img.image_data.img_resolution,
                        "created_at": new Date(Number(img.time_updated)).toDateString(),
                        "captured_by": img.captured_by,
                        "platform": initial['platform'],
                    });
                }
            });
            image_list = image_list.concat(silo_image);

        }

        if (initial['lifestyle_data'] && initial['lifestyle_data'].length > 0) {
            let lifestyle_image = [];
            initial['lifestyle_data'].map((img) => {
                let image_link = '';
                image_link = ENVIRONMENT.getBaseURL(img.platform) + ENVIRONMENT.SCENE_THUMBNAIL_URI + img.scene_id + '/' + img.filename
                let filename = image_link.split('/').pop();
                let display_name = img.display_name ? img.display_name : (img.camera_name.split('.')[0] || '');

                lifestyle_image.push({
                    "format": Utilities.getImageFormat(image_link),
                    "link": image_link.replace('tiff', 'jpg'),
                    "low_url": image_link.replace('tiff', 'jpg'),
                    "type": 'lifestyle',
                    "main_type": "lifestyle",
                    "status": img.status == "rendered" ? "completed" : img.status,
                    "filename": filename,
                    "display_name": display_name,
                    "scene_id": img.scene_id,
                    "resolution": img.height + '×' + img.width,
                    "created_at": new Date(Number(img.time_updated)).toDateString(),
                    "captured_by": img.captured_by,
                    "platform": initial['platform'],
                });
            })
            lifestyle_image.sort((a, b) => {
                // Split resolution into height and width
                let [aHeight, aWidth] = a.resolution.split('×').map(Number);
                let [bHeight, bWidth] = b.resolution.split('×').map(Number);

                // Find the maximum dimension (height or width) for each resolution
                let aMax = Math.max(aHeight, aWidth);
                let bMax = Math.max(bHeight, bWidth);

                // Sort by the largest dimension (descending)
                if (aMax !== bMax) {
                    return bMax - aMax; // Sort by the largest dimension in descending order
                } else {
                    // If the largest dimensions are equal, sort by the other dimension (descending)
                    let aMin = Math.min(aHeight, aWidth);
                    let bMin = Math.min(bHeight, bWidth);
                    return bMin - aMin;
                }
            });

            image_list = image_list.concat(lifestyle_image);

        }

        const fetchData = async () => {
            if (!initial['2d'][0]) {
                return;
            }
            let name = initial['2d'][0].split('/').pop().split('.')[0];
            let idBeforeUnderscore = name.split('_')[0];

            try {
                const jsonDataUrl = `https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders_info/${idBeforeUnderscore}.json`;
                const response = await axios.get(jsonDataUrl);

                initial['2d'].map((img) => {
                    console.log('Processing:', img);
                    let type = "low_res_preview";
                    let low_url = img.replace('/perspective_renders/', '/low_res_perspective_renders/')
                        .replace(ENVIRONMENT.DEFAULT_BASE_URL, ENVIRONMENT.getBaseURL(initial.platform));

                    if (img.includes('_Dimensions')) {
                        type = "low_res_preview";
                        if (img.includes(CUSTOMER_USERNAME) || img.includes('company')) {
                            type = 'dim';
                        }
                        low_url = img.replace('/dimensional_renders/', '/low_res_dimensional_renders/')
                            .replace(ENVIRONMENT.DEFAULT_BASE_URL, ENVIRONMENT.getBaseURL(initial.platform));
                    }

                    let filename = img.split('/').pop();
                    let display_name = img.split('/').pop().split('.')[0];
                    let img_data = response.data[filename];

                    let width = img_data?.width || '';
                    let height = img_data?.height || '';
                    let timeUpdated = img_data?.time_updated || '';

                    image_list.push({
                        "format": Utilities.getImageFormat(img),
                        "link": img,
                        "low_url": low_url,
                        "type": type,
                        "main_type": type,
                        "status": "rendered",
                        "filename": filename,
                        "display_name": display_name,
                        "resolution": height + '×' + width,
                        "created_at": timeUpdated ? new Date(Number(timeUpdated)).toDateString() : '',

                        "platform": initial['platform'],
                    });

                    console.log('Width:', width || 'N/A');
                    console.log('Height:', height || 'N/A');
                    console.log('Time Updated:', timeUpdated ? new Date(Number(timeUpdated)).toDateString() : 'N/A');
                });
            } catch (error) {
                console.error('Error fetching data:', error);

                // Ensure image_list is populated even if the API fails
                initial['2d'].map((img) => {
                    let type = "low_res_preview";
                    let low_url = img.replace('/perspective_renders/', '/low_res_perspective_renders/')
                        .replace(ENVIRONMENT.DEFAULT_BASE_URL, ENVIRONMENT.getBaseURL(initial.platform));

                    if (img.includes('_Dimensions')) {
                        type = "low_res_preview";
                        if (img.includes(CUSTOMER_USERNAME) || img.includes('company')) {
                            type = 'dim';
                        }
                        low_url = img.replace('/dimensional_renders/', '/low_res_dimensional_renders/')
                            .replace(ENVIRONMENT.DEFAULT_BASE_URL, ENVIRONMENT.getBaseURL(initial.platform));
                    }

                    let filename = img.split('/').pop();
                    let display_name = img.split('/').pop().split('.')[0];
                    image_list.push({
                        "format": Utilities.getImageFormat(img),
                        "link": img,
                        "low_url": low_url,
                        "type": type,
                        "main_type": type,
                        "status": "rendered",
                        "filename": filename,
                        "display_name": display_name,
                        "resolution": '',
                        "created_at": '',
                        "platform": initial['platform'],
                    });

                    console.log('Width:', 'N/A');
                    console.log('Height:', 'N/A');
                    console.log('Time Updated:', 'N/A');
                });
            }

            initial['download_links'].map((img) => {
                if (img.display_name == ("AI GENERATED GLB")) {
                    image_list.push({
                        "format": Utilities.getImageFormat(img.model_url),
                        "link": img.model_url,
                        "type": "3d_model_ai",
                        "platform": initial['platform'],
                    });
                }
                if (img.display_name == ("GLB")) {
                    image_list.push({
                        "format": Utilities.getImageFormat(img.model_url),
                        "link": img.model_url,
                        "type": "3d_model",
                        "platform": initial['platform'],
                    });
                }
            })
            // Ensure all processing is done before setting the state and calling functions
            let images = image_list;
            images = image_list.filter(image => ['jpg', 'jpeg', 'png', 'svg', 'glb', 'obj', 'zip'].includes(image.format));

            // Remove duplicates based on the 'link' field
            const uniqueImages = images.filter(
                (image, index, self) =>
                    index === self.findIndex((t) => t.link === image.link)
            );

            setProductImages(uniqueImages);
            console.log('Total images:', uniqueImages);
        };
        fetchData();
    }

    const addImages = (product_image) => {
        const alreadySelected = selectedImages.some(img => img.link === product_image.link);

        let updatedImages;
        if (alreadySelected) {
            updatedImages = selectedImages.filter(img => img.link !== product_image.link);
        } else {
            updatedImages = [...selectedImages, product_image];
        }

        setSelectedImages(updatedImages);
    };

    return <>
        <Modal
            title={<div className="manrope f-14 lh-22 w-500 black-085"><ArrowLeftOutlined onClick={goBack} className='cursor-pointer' />&nbsp;
                Add Reference Assets</div>}
            closable={true}
            onCancel={cancelAddProductModal}
            className="add-product-modal-ai"
            bodyStyle={{ padding: 0, height: '90vh' }}
            footer={null}
            visible={openProductImageSelectionModal}>
            <>
                {selectionStage == "product_selection" ?
                    <>
                        <Row className="header-container" style={{ paddingTop: 24, paddingBottom: 30 }}>
                            <Col span={8}>
                                <span className="manrope f-24 w-600 black-00">Select a product</span>
                            </Col>
                            <Col span={16} className="justify-in-end">
                                <Input className="manrope f-14 grey-99 pd-8 search-bar-width search-bar-border" placeholder="Search Products"
                                    onChange={e => { changeSearchValue(e.target.value) }}
                                />
                            </Col>
                        </Row>
                        <div className="swap-container">
                            <Tabs
                                onChange={(key) => setLibraryType(key)}
                                className="product-tab library"
                                tabBarGutter={16}
                                size="large"
                                activeKey={libraryType}
                            >
                                {tabs?.map((tab, index) => {
                                    return (
                                        <TabPane
                                            tab={getTabTitle(tab)}
                                            key={tab.key}
                                            style={{ padding: "0px 10px" }}
                                        >
                                            {tab.loader ?
                                                <DottedLoader />
                                                :
                                                <Row className='product-grid-row-product qa comment-input-box__suggestions' >
                                                    {tab.length > 0 ?
                                                        tab.data.map((ele) => {
                                                            return (
                                                                <Col span={6}>
                                                                    <Card
                                                                        onClick={() => handleAddAction(ele)}
                                                                        className={`card-shadow-product product-card-ai`}>
                                                                        <div
                                                                            className="suggested-product"
                                                                            target="_blank"
                                                                            style={{ zIndex: '1' }}
                                                                        >
                                                                            {selectedProductId != ele.id ?
                                                                                <PlusOutlined
                                                                                    title="Select a product"
                                                                                    className="item-icons plus"
                                                                                    onClick={() => handleAddAction(ele)}
                                                                                    style={{ zIndex: 3 }}
                                                                                /> : <CheckOutlined title="Product selected"
                                                                                    className="item-icons plus button-checked black"
                                                                                    style={{ zIndex: 3 }}
                                                                                    onClick={() => handleAddAction(ele)} />}
                                                                            <div className="box">
                                                                                <img
                                                                                    key={ele.id}
                                                                                    className="product-image space-card-img h-250"
                                                                                    src={ele.thumbnail.replace(ENVIRONMENT.DEFAULT_BASE_URL, ENVIRONMENT.getBaseURL(ele.platform)) || require('../../../../assets/images/chair.png')}
                                                                                />
                                                                            </div>
                                                                            <div className='justify-in-start' style={{ margin: '12px 12px 8px 12px' }}>
                                                                                <span className='manrope f-14 w-500' style={{
                                                                                    backgroundColor: '#F0F5FF',
                                                                                    padding: '7px 10px',
                                                                                    borderRadius: '6px',
                                                                                    color: '#1D39C4',
                                                                                    marginRight: 6
                                                                                }}>Product</span>
                                                                                {ele.is_ai_model && <AiProductBadge />}
                                                                            </div>
                                                                            <div className='justify-in-start' style={{ margin: '12px 12px 8px 12px' }}>
                                                                                <Tooltip title={<span className="manrope f-12 white"> {ele.name}</span>}>
                                                                                    <div
                                                                                        className="justify-in-start manrope f-14 w-500 black-00 clamp-text w-100">
                                                                                        {ele.name}
                                                                                    </div>
                                                                                </Tooltip>
                                                                                {ele.last_modified_stamp ?
                                                                                    <Tooltip title={<span className="manrope f-12 white"> {Utilities.timestampToTimeSince(ele.last_modified_stamp, "tooltip")} </span>}>
                                                                                        <span className="manrope f-12 grey-77 w-500 time-clock-bg" style={{ marginLeft: 4 }}>
                                                                                            <img src="/img/carbon_time.svg" style={{ marginRight: 2 }} /> {Utilities.timestampToTimeSince(ele.last_modified_stamp)}
                                                                                        </span>
                                                                                    </Tooltip> : ''}
                                                                            </div>
                                                                            {ele.category ? (

                                                                                <div
                                                                                    className="justify-in-start manrope f-12 grey-77 capitalize"
                                                                                    style={{
                                                                                        marginLeft: '12px',
                                                                                        marginRight: '12px',
                                                                                        marginBottom: '8px',
                                                                                        textAlign: 'left',
                                                                                    }}
                                                                                >    <span className="manrope f-14 grey-77 capitalize" style={{ marginRight: 4 }}>{'Category'}</span>

                                                                                    <Tooltip title={<span className='manrope f-12 white'>{ele.category}</span>}>
                                                                                        <span className="manrope f-14 black-33 capitalize clamp-w-width">{ele.category}</span>
                                                                                    </Tooltip>
                                                                                </div>

                                                                            ) : (
                                                                                ''
                                                                            )}

                                                                            {ele.brand_id ?
                                                                                <div className="justify-in-start" style={{ marginBottom: "8px", marginLeft: "12px", marginRight: "12px", textAlign: "left" }}>
                                                                                    <span style={{ marginRight: 4 }} className='manrope f-14 grey-77 capitalize'>Item&nbsp;ID</span>
                                                                                    <Tooltip title={<span className='manrope f-12 white'>{ele.brand_id}</span>}>
                                                                                        <span className="manrope f-14 black-33 capitalize clamp-w-width">{ele.brand_id || 'N/A'}</span>
                                                                                    </Tooltip>
                                                                                </div> : ''}

                                                                            <div className="justify-in-start manrope f-14 grey-77 capitalize" style={{ marginBottom: 12, marginLeft: "12px", marginRight: "12px", textAlign: "left" }}>
                                                                                <div style={{ marginRight: 4 }}>{'Dims'}</div>
                                                                                {(Array.isArray(ele.dimensions)) ? <div className="manrope f-14 black-33">N/A</div> : <div className="manrope f-14 black-33">
                                                                                    D {Math.round(ele.dimensions.depth)}" W {Math.round(ele.dimensions.width)}" H {Math.round(ele.dimensions.height)}"</div>}
                                                                            </div>
                                                                        </div>
                                                                    </Card>
                                                                </Col>
                                                            )
                                                        })
                                                        :
                                                        <Col span={24} className="no-models-div" style={{ position: 'relative', height: '100%' }}>
                                                            <Empty description={"No Models To Show Yet"} className="manrope f-14 no-models-span-modal" />
                                                        </Col>

                                                    }

                                                </Row>
                                            }

                                        </TabPane>
                                    );
                                })}
                            </Tabs>
                        </div>
                    </> : <>

                        {productImages?.length > 0 &&
                            <Row className="header-container" style={{ paddingTop: 24, paddingBottom: 30 }}>
                                <Col span={24} className='justify-in-start'>
                                    <span className="manrope f-24 w-600 black-00">Select assets to add</span>
                                </Col>
                            </Row>}
                        <div className={`swap-container custom-scroll product-grid-list ${productImages?.length == 0 ? `empty` : `qa-editor`}`}>
                            {productImages.filter((img) => ['3d_model', '3d_model_ai'].includes(img.type)).length > 0 &&
                                <>
                                    <div className='manrope f-16 lh-24 w-500 black-085' style={{ marginBottom: 24 }}>
                                        3D Model
                                    </div>
                                    <div className='display-flex j-s a-s wrap sa-s gg-16 w-100' style={{ marginBottom: 8 }}>
                                        {productImages.filter((img) => ['3d_model', '3d_model_ai'].includes(img.type)).map((product_image, index) => (
                                            <Card style={{ marginRight: 16, marginBottom: 16 }} className={`product-qa-select-img-card ${selectedImages.some(img => img.link === product_image.link) ? `selected` : ``}`} onClick={() => addImages(product_image)}>
                                                {!selectedImages.some(img => img.link === product_image.link) ?
                                                    <PlusOutlined
                                                        title="Select image"
                                                        className="item-icons plus"
                                                        onClick={() => addImages(product_image)}
                                                        style={{ zIndex: 3 }}
                                                    /> : <CheckOutlined title="Asset selected"
                                                        className="item-icons plus button-checked black"
                                                        style={{ zIndex: 3 }}
                                                        onClick={() => addImages(product_image)} />}
                                                <img src={productAssetData['2d'][0]} className='product-qa-select-img' />
                                                {['3d_model_ai'].includes(product_image.type) &&
                                                    <div className='position-absolutely-ai-container'>
                                                        <AiProductBadge />
                                                    </div>}
                                                <div className='position-absolutely-glb-container'>
                                                    <div className='product-model-glb-icon-container'>
                                                        <img className='product-model-glb-icon' src={'/img/3d.jpg'} />
                                                    </div>
                                                </div>
                                            </Card>
                                        ))}
                                    </div>
                                </>}
                            {productImages.filter((img) => ['low_res_preview'].includes(img.type)).length > 0 &&
                                <>
                                    <div className='manrope f-16 lh-24 w-500 black-085' style={{ marginBottom: 24 }}>
                                        Preview Images
                                    </div>
                                    <div className='display-flex j-s a-s wrap sa-s gg-16 w-100' style={{ marginBottom: 8 }}>
                                        {productImages.filter((img) => ['low_res_preview'].includes(img.type)).map((product_image, index) => (
                                            <Card style={{ marginRight: 16, marginBottom: 16 }} className={`product-qa-select-img-card ${selectedImages.some(img => img.link === product_image.link) ? `selected` : ``}`} onClick={() => addImages(product_image)}>
                                                {!selectedImages.some(img => img.link === product_image.link) ?
                                                    <PlusOutlined
                                                        title="Select image"
                                                        className="item-icons plus"
                                                        onClick={() => addImages(product_image)}
                                                        style={{ zIndex: 3 }}
                                                    /> : <CheckOutlined title="Asset selected"
                                                        className="item-icons plus button-checked black"
                                                        style={{ zIndex: 3 }}
                                                        onClick={() => addImages(product_image)} />}
                                                <img src={product_image.link} className='product-qa-select-img' />
                                            </Card>
                                        ))}
                                    </div>
                                </>}
                            {productImages.filter((img) => ['dim'].includes(img.type)).length > 0 &&
                                <>
                                    <div className='manrope f-16 lh-24 w-500 black-085' style={{ marginBottom: 24 }}>
                                        Dimensional Images
                                    </div>
                                    <div className='display-flex j-s a-s wrap sa-s gg-16 w-100' style={{ marginBottom: 8 }}>
                                        {productImages.filter((img) => ['dim'].includes(img.type)).map((product_image, index) => (
                                            <Card style={{ marginRight: 16, marginBottom: 16 }} className={`product-qa-select-img-card ${selectedImages.some(img => img.link === product_image.link) ? `selected` : ``}`} onClick={() => addImages(product_image)}>
                                                {!selectedImages.some(img => img.link === product_image.link) ?
                                                    <PlusOutlined
                                                        title="Select image"
                                                        className="item-icons plus"
                                                        onClick={() => addImages(product_image)}
                                                        style={{ zIndex: 3 }}
                                                    /> : <CheckOutlined title="Asset selected"
                                                        className="item-icons plus button-checked black"
                                                        style={{ zIndex: 3 }}
                                                        onClick={() => addImages(product_image)} />}
                                                <img src={product_image.link} className='product-qa-select-img' />
                                            </Card>
                                        ))}
                                    </div>
                                </>}
                            {productImages.filter((img) => ['silo', 'blind', 'swatch'].includes(img.type)).length > 0 &&
                                <>
                                    <div className='manrope f-16 lh-24 w-500 black-085' style={{ marginBottom: 24 }}>
                                        Silo Images
                                    </div>
                                    <div className='display-flex j-s a-s wrap sa-s gg-16 w-100' style={{ marginBottom: 8 }}>
                                        {productImages.filter((img) => ['silo', 'blind', 'swatch'].includes(img.type)).map((product_image, index) => (
                                            <Card style={{ marginRight: 16, marginBottom: 16 }} className={`product-qa-select-img-card ${selectedImages.some(img => img.link === product_image.link) ? `selected` : ``}`} onClick={() => addImages(product_image)}>
                                                {!selectedImages.some(img => img.link === product_image.link) ?
                                                    <PlusOutlined
                                                        title="Select image"
                                                        className="item-icons plus"
                                                        onClick={() => addImages(product_image)}
                                                        style={{ zIndex: 3 }}
                                                    /> : <CheckOutlined title="Asset selected"
                                                        className="item-icons plus button-checked black"
                                                        style={{ zIndex: 3 }}
                                                        onClick={() => addImages(product_image)} />}
                                                <img src={product_image.link} className='product-qa-select-img' />
                                            </Card>
                                        ))}
                                    </div>
                                </>}

                            {productImages.filter((img) => ['lifestyle'].includes(img.type)).length > 0 &&
                                <>
                                    <div className='manrope f-16 lh-24 w-500 black-085' style={{ marginBottom: 24 }}>
                                        Lifestyle Images
                                    </div>
                                    <div className='display-flex j-s a-s wrap sa-s gg-16 w-100' style={{ marginBottom: 8 }}>
                                        {productImages.filter((img) => ['lifestyle'].includes(img.type)).map((product_image, index) => (
                                            <Card style={{ marginRight: 16, marginBottom: 16 }} className={`product-qa-select-img-card ${selectedImages.some(img => img.link === product_image.link) ? `selected` : ``}`} onClick={() => addImages(product_image)}>
                                                {!selectedImages.some(img => img.link === product_image.link) ?
                                                    <PlusOutlined
                                                        title="Select image"
                                                        className="item-icons plus"
                                                        onClick={() => addImages(product_image)}
                                                        style={{ zIndex: 3 }}
                                                    /> : <CheckOutlined title="Asset selected"
                                                        className="item-icons plus button-checked black"
                                                        style={{ zIndex: 3 }}
                                                        onClick={() => addImages(product_image)} />}
                                                <img src={product_image.link} className='product-qa-select-img' />
                                            </Card>
                                        ))}
                                    </div>
                                </>}

                            {allAiImages.filter((img) => ['low_res_preview'].includes(img.type)).length > 0 &&
                                <>
                                    <div className='manrope f-16 lh-24 w-500 black-085' style={{ marginBottom: 24 }}>
                                        AI Lifestyles
                                    </div>
                                    <div className='display-flex j-s a-s wrap sa-s gg-16 w-100' style={{ marginBottom: 8 }}>
                                        {allAiImages.filter((img) => ['low_res_preview'].includes(img.type)).map((product_image, index) => (
                                            <Card style={{ marginRight: 16, marginBottom: 16 }} className={`product-qa-select-img-card ${selectedImages.some(img => img.link === product_image.link) ? `selected` : ``}`} onClick={() => addImages(product_image)}>
                                                {!selectedImages.some(img => img.link === product_image.link) ?
                                                    <PlusOutlined
                                                        title="Select image"
                                                        className="item-icons plus"
                                                        onClick={() => addImages(product_image)}
                                                        style={{ zIndex: 3 }}
                                                    /> : <CheckOutlined title="Asset selected"
                                                        className="item-icons plus button-checked black"
                                                        style={{ zIndex: 3 }}
                                                        onClick={() => addImages(product_image)} />}
                                                <img src={product_image.link} className='product-qa-select-img' />
                                            </Card>
                                        ))}
                                    </div>
                                </>}

                            {productImages.filter((img) => !['lifestyle', 'low_res_preview', 'silo', 'blind', 'swatch', 'low_res_preview', '3d_model', '3d_model_ai', 'dim'].includes(img.type)).length > 0 &&
                                <>
                                    <div className='manrope f-16 lh-24 w-500 black-085' style={{ marginBottom: 24 }}>
                                        Reference Assets
                                    </div>
                                    <div className='display-flex j-s a-s wrap sa-s gg-16 w-100' style={{ marginBottom: 8 }}>
                                        {productImages.filter((img) => !['lifestyle', 'low_res_preview', 'silo', 'blind', 'swatch', 'low_res_preview', '3d_model', 'dim', '3d_model_ai'].includes(img.type)).map((product_image, index) => (
                                            <Card style={{ marginRight: 16, marginBottom: 16 }} className={`product-qa-select-img-card ${selectedImages.some(img => img.link === product_image.link) ? `selected` : ``}`} onClick={() => addImages(product_image)}>
                                                {!selectedImages.some(img => img.link === product_image.link) ?
                                                    <PlusOutlined
                                                        title="Select image"
                                                        className="item-icons plus"
                                                        onClick={() => addImages(product_image)}
                                                        style={{ zIndex: 3 }}
                                                    /> : <CheckOutlined title="Asset selected"
                                                        className="item-icons plus button-checked black"
                                                        style={{ zIndex: 3 }}
                                                        onClick={() => addImages(product_image)} />}
                                                {['glb'].includes((product_image.format)) ?
                                                    <img className='product-qa-select-img' src="/img/glb_file.png" /> :
                                                    ['obj'].includes((product_image.format)) ?
                                                        <img className='product-qa-select-img' src="/img/obj_icon.png" /> :
                                                        ['zip'].includes((product_image.format)) ?
                                                            <img className='product-qa-select-img' src="/img/zip_file.png" /> :
                                                            <img src={product_image.link} className='product-qa-select-img' />}
                                            </Card>
                                        ))}
                                    </div>
                                </>}
                            {productImages?.length == 0 && !productDataLoader &&
                                <Empty
                                    className='position-empty-data'
                                    description={
                                        <span className="manrope f-14 black-085">
                                            No assets to select
                                        </span>
                                    }
                                />}
                            {productDataLoader ? <div>
                                <LoadingOutlined style={{ fontSize: 50 }} className="loading-center" />
                            </div> : ''}

                        </div>
                    </>
                }

                <Row className="swap-modal-footer justify-in-end" style={{ zIndex: 3 }}>
                    <Button
                        disabled={productDataLoader}
                        style={{ marginRight: 10 }}
                        className='basic-grey-btn f-14'
                        onClick={cancelAddProductModal}>
                        Cancel
                    </Button>
                    {selectionStage == "product_selection" ? <Button disabled={selectedProductId == -1 || productDataLoader} onClick={handleConfirm} className="modal-okay square font-14">
                        Confirm{productDataLoader && <LoadingOutlined />}
                    </Button> : <Button disabled={selectedImages.length == 0} onClick={handleAdd} className="modal-okay square font-14">
                        Add
                    </Button>}
                </Row>
            </>
        </Modal>

    </>
}

export default ProductAssetSelectionModal;